import React from 'react';
import { Box, Slider, TextField, Typography } from '@mui/material';
import 'mapbox-gl/dist/mapbox-gl.css';
import styled from 'styled-components';

const Toolbar = styled(Box)`
  box-shadow: 0px 3px 3px -2px rgb(0 0 0 / 20%), 0px 3px 4px 0px rgb(0 0 0 / 14%), 0px 1px 8px 0px rgb(0 0 0 / 12%);
`

type MapToolbarProps = {
  fovWidth: number;
  setFovWidth: (value: React.SetStateAction<number>) => void
  fovRange: number;
  setFovRange: (value: React.SetStateAction<number>) => void;
  angleEastOfNorth: number;
  setAngleEastOfNorth: (value: React.SetStateAction<number>) => void;
  onFovWidthChange?: (value: number) => void;
  onAngleEastOfNorthChange?: (value: number) => void;
  onFovRangeChange?: (value: number) => void;
  left?: string;
}

const MapToolbar: React.FC<MapToolbarProps> = (props) => {
  const {
    fovWidth,
    setFovWidth,
    fovRange,
    setFovRange,
    angleEastOfNorth,
    setAngleEastOfNorth,
    onFovWidthChange,
    onAngleEastOfNorthChange,
    onFovRangeChange,
    left
  } = props;

  return (
    <Toolbar
      bgcolor="white"
      borderRadius="12px"
      padding="1rem"
      width="20vw"
      position="absolute"
      display="grid"
      gridTemplateRows="min-content min-content"
      bottom="1rem"
      left={left || "40vw"}
      data-cy="map-toolbar-container"
    >
      <Box
        width="100%"
        display="grid"
        gridTemplateRows="min-content auto"
        data-cy="map-toolbar-fov-width-container"
      >
        <Typography style={{ fontWeight: 550 }} variant="body2">Field of view</Typography>
        <Slider
          min={0}
          max={180}
          valueLabelDisplay="auto"
          value={fovWidth}
          onChange={(_e, v) => {
            setFovWidth(+v)
            if (onFovWidthChange) onFovWidthChange(+v);
          }}
        />
      </Box>
      <Box
        display="grid"
        gridTemplateColumns="1fr 1fr"
        gap="1rem"
        width="100%"
        data-cy="camera-input-container"
      >
        <Box data-cy="camera-range-input">
          <TextField
            id="fov-range-input"
            value={fovRange}
            onChange={(e) => {
              if (!isNaN(Number(e.target.value))) {
                setFovRange(+e.target.value)
                if (onFovRangeChange) onFovRangeChange(+e.target.value);
              }
            }}
            label="Range"
            fullWidth
            size="small"
            variant="outlined"
          />
        </Box>
        <Box data-cy="angle-east-of-north-range-input">
          <TextField
            id="enagle-east-of-north-input"
            value={angleEastOfNorth}
            onChange={(e) => {
              if (!isNaN(Number(e.target.value))) {
                setAngleEastOfNorth(+e.target.value);
                if (onAngleEastOfNorthChange) onAngleEastOfNorthChange(+e.target.value);
              }
            }}
            label="Rotation"
            fullWidth
            size="small"
            variant="outlined"
          />
        </Box>
      </Box>
    </Toolbar>
  );
}

export default MapToolbar;
